<template>
  <div v-click-outside="handleClickOutside" class="tool-wrapper">
    <div @click="toggleIsShowToolList" class="tool-header">
      <div class="tool-header__text">
        {{ selectedOption.text ? selectedOption.text : toolConfig.placeholder }}
      </div>
      <div>
        <fa icon="sort"></fa>
      </div>
    </div>
    <div v-if="isShowToolList" class="tool-list">
      <Spinner v-if="isProcessing" :fullscreen="true">Processing</Spinner>
      <div
        v-for="(tool, index) in toolConfig.toolList"
        :key="index"
        class="sort-list__wrapper"
      >
        <div
          @click="selectTool(tool.id)"
          class="tool"
          :class="{
            active:
              tool.id === selectedOption.id ||
              (tool.id === 0 && selectedOption.id === null)
          }"
        >
          {{ tool.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as vClickOutside from 'v-click-outside';
import Spinner from '../../../ui/Spinner.vue';

export default {
  name: 'SortAndFilterToolAlertsRS',
  components: { Spinner },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    toolConfig: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0,
      isShowToolList: false,
      isProcessing: false,
      selectedOption: {
        id: null,
        text: ''
      }
    };
  },
  methods: {
    toggleIsShowToolList() {
      this.isShowToolList = !this.isShowToolList;
    },

    selectTool(toolId) {
      this.selectedOption = this.toolConfig.toolList.find(
        tool => tool.id === toolId
      );

      this.toggleIsShowToolList();
      this.$emit('onToolChange', toolId);
    },
    handleClickOutside() {
      this.isShowToolList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.tool-wrapper {
  position: relative;
}

.tool-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  width: 100%;
  height: 2.5rem;
  border: 1px solid $text-grey;
  background-color: #fff;
  color: $text-black;

  &__text {
    font-weight: 600;
  }
}

.tool-list {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid $text-grey;
  background-color: #fff;
  color: $text-black;

  .tool {
    width: 100%;
    height: 3rem;
    padding: 0 1rem;
    line-height: 3rem;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background-color: #ccc;
    }

    &.active {
      color: white;
      background-color: $text-light-blue;
    }
  }
}
</style>
